export default __webpack_public_path__ + "static/media/complete.acd17e54.png";